import React from 'react';
import { router } from '../../../shared/hashRouter';

// Индикатор шагов чекаута. Средний шаг («Подписание акта») рисуется только
// когда он реально нужен: иначе у компаний без аренды тары сменилась бы
// нумерация уже привычных шагов.
//
// props: active — номер текущего шага (1..3), hasSign — нужен ли шаг подписи
export function CheckoutSteps({ active, hasSign }) {
  const steps = [{ n: 1, title: 'Доставка', hash: '#checkout' }];
  if (hasSign) steps.push({ n: 2, title: 'Подписание акта', hash: '#tare_sign' });
  steps.push({ n: hasSign ? 3 : 2, title: 'Оплата', hash: '#payment' });

  return (
    <div className="ng-checkout__steps">
      {steps.map((s, i) => {
        const isActive = (i + 1) === active;
        const cls = 'ng-checkout__step' + (isActive ? ' ng-checkout__step--active' : '');
        // Назад ходить можно, вперёд — только через кнопки формы
        if (!isActive && (i + 1) < active) {
          return (
            <a
              key={s.title}
              href="#"
              className={cls}
              onClick={(e) => { e.preventDefault(); router.go(s.hash); }}
            >
              {s.n}. {s.title}
            </a>
          );
        }
        return <span key={s.title} className={cls}>{s.n}. {s.title}</span>;
      })}
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/Checkout/CheckoutSteps.jsx